import React, { useRef, useState, useLayoutEffect, useEffect } from 'react'
import Input from '../input/input'

function Dropdown({ active, data, children, style, positon = 'top-[100%] absolute', minWidth, searchFieldFor }) {
  const ref = useRef()
  const [state, setState] = useState({})
  const [filteredData, setFilteredData] = useState(data)
  const [searchQuery, setSearchQuery] = useState('')

  useEffect(() => {
    if(searchQuery) {
      const filteredData = data.filter(el => (el[searchFieldFor].toLowerCase()).includes(searchQuery.toLowerCase()))
      setFilteredData(filteredData)
    } else {
      setFilteredData(data)
    }
  }, [data, searchQuery])

  const onChangeSearchQuery = (e) => {
    setSearchQuery(e.target.value)
  }

  useLayoutEffect(() => {
    const { height, y } = ref.current.getBoundingClientRect()
    const container = ref.current.parentElement.parentElement?.getBoundingClientRect()
    if (y + height > window.innerHeight) {
      setState({
        height,
        offset: container?.height
      })
    } else {
      setState({})
    }
  }, [active])

  return (
    <div
      style={
        style
          ? style
          : {
              // marginTop: state.height ? (state.height + (state.offset || 0))*-1 + 'px' : null
              marginTop: state.height ? (state.height + (state.offset || 0)) * -1 + 'px' : null
            }
      }
      ref={ref}
      className={`
			${positon}
			${active ? '' : 'd-none invisible opacity-0 '}
			shadow-default  left-0 right-0  z-10  bg-white   max-h-[33.5rem] overflow-auto
			${minWidth || ''}
			`}>
      {searchFieldFor &&  <div className={`p-[1rem]`}>
        <Input small border={true} placeholder={'Поиск'} onInput={onChangeSearchQuery} initial={searchQuery}></Input>
      </div>}
      {filteredData?.length ? filteredData.map(children) : <span></span>}
    </div>
  )
}

export default Dropdown
